import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "content",
  "use": "content-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"content\"><rect x=\".75\" y=\".929\" width=\"14.5\" height=\"11.643\" rx=\"1.536\" stroke=\"currentColor\" stroke-width=\"1.5\" /><path stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" d=\"M11.82 4.929H4.177M9.535 8.357H4.178\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol